export default __webpack_public_path__ + "static/media/AdobeStock_260282528.cafcb60f.jpg";